import * as React from 'react';
import {
  WidgetWrapper,
  WidgetText,
} from '../core/DashbardGridStyledComponents';
import './ProgressWidget.css';

const ClockWidget: React.FC<any> = ({ options }) => {
  const { titleClasses, valueClasses } = options;
  const [date, setDate] = React.useState('');
  const [time, setTime] = React.useState('');

  const updateClock = () => {
    let currentDate = new Date();
    let months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    let hours = currentDate.getHours();
    let minutes = currentDate.getMinutes().toString();
    let seconds = currentDate.getSeconds().toString();
    let AMPM = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes.length === 1 ? '0' + minutes : minutes;
    seconds = seconds.length === 1 ? '0' + seconds : seconds;
    setTime(hours + ':' + minutes + ':' + seconds + ' ' + AMPM);
    setDate(
      [
        currentDate.getDate(),
        months[currentDate.getMonth()],
        currentDate.getFullYear(),
      ].join(' ')
    );
    return setTimeout(updateClock, 1000);
  };

  React.useEffect(() => {
    const clockTimeout = updateClock();

    return () => {
      clearTimeout(clockTimeout);
    };
  }, [date, time]);

  return (
    <WidgetWrapper>
      <WidgetText size="medium" {...titleClasses}>
        {date}
      </WidgetText>
      <WidgetText bold color="#c53030" {...valueClasses}>
        {time}
      </WidgetText>
    </WidgetWrapper>
  );
};

export default ClockWidget;
